import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'sa-ui';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './simulatedQuestionsMessages';

const ReproveQuestionModal = props => {
  const [reason, setReason] = React.useState('');

  React.useEffect(() => {
    setReason('');
  }, [props.show]);

  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      icon="ti-close"
      title={<FormattedMessage {...messages.repproved} />}
      buttons={[
        {
          label: <FormattedMessage {...messages.close} />,
          onClick: props.onClose,
        },
        {
          label: <FormattedMessage {...messages.continue} />,
          onClick: () => props.onContinue(reason),
          disabled: reason.length < 140,
          primary: true,
        },
      ]}
    >
      <div className="mt-3">
        <p className="subtitle subtitle-big w-75 m-auto mt-3">
          <FormattedMessage {...messages.repprovedMessage} values={props.question} />
        </p>
        <div className="form-group">
          <FormattedMessage {...messages.reasonInput}>
            {txt => (
              <textarea
                className="form-control"
                placeholder={txt}
                value={reason}
                style={{ width: '100%' }}
                onChange={e => setReason(e.target.value)}
              />
            )}
          </FormattedMessage>
          <FormattedMessage {...messages.characters} values={{ count: reason.length, number: 140 }}>
            {txt => <small>{txt}</small>}
          </FormattedMessage>
        </div>
      </div>
    </Modal>
  );
};

ReproveQuestionModal.propTypes = {};

export default ReproveQuestionModal;
